import VenueNoteView from "@/features/home/VenuePreview/VenueNoteView";
import EmptyMapperNotes from "@/assets/images/empty-mappernotes.svg";

type PublicViewProps = {
  publicNotes: any[];
  onRefresh: () => void;
  onEdit: (note: any) => void;
  onFlagNote: (note: any) => void;
  showMapperView: boolean;
  selectedActionTitle?: string;
  noteActions?: any[];
};

const PublicView = ({
  publicNotes,
  onRefresh,
  onEdit,
  onFlagNote,
  selectedActionTitle,
  noteActions,
}: PublicViewProps) => {
  // Filter notes for the selected action
  const filteredNotes = selectedActionTitle
    ? publicNotes.filter(note => {
        const actionTitle = note.action_title || 
                          (note.note && note.note.action_title) || 
                          (note.details && note.details.action_title);
        return actionTitle === selectedActionTitle;
      })
    : publicNotes;

  if (filteredNotes.length === 0) {
    // Find other actions that have notes
    const otherActionsWithNotes = noteActions?.filter(action => {
      if (action.title === selectedActionTitle) return false;
      
      // Check if any note has this action title
      return publicNotes.some(note => {
        const noteActionTitle = note.action_title || 
                              (note.note && note.note.action_title) || 
                              (note.details && note.details.action_title);
        return noteActionTitle === action.title;
      });
    });

    return (
      <div className="flex-1 m-auto w-full">      
        <p className="text-center paragraph-medium-semi-bold  my-10" tabIndex={0}>
          {selectedActionTitle 
            ? `No ${selectedActionTitle} for this venue yet.`
            : "No notes for this venue yet"}
        </p>
        <p className="text-center paragraph-small-regular mt-3" tabIndex={0}>
          {otherActionsWithNotes && otherActionsWithNotes.length > 0
            ? `Check ${otherActionsWithNotes.map(a => a.title).join(", ")} instead.`
            : ""}
        </p>
        <img
          src={EmptyMapperNotes}
          alt="No search results"
          className="max-w-[70%] mx-auto"
          aria-hidden="true"
        />
      </div>
    );
  }

  return (
    <div className="mt-2 grid md:grid-cols-2 grid-cols-1 gap-4">
      {filteredNotes.map((note, index) => (
        <VenueNoteView
          key={index}
          note={note}
          onRefresh={onRefresh}
          onEdit={() => onEdit(note)}
          onFlagNote={() => onFlagNote(note)}
        />
      ))}
    </div>
  );
};

export default PublicView; 